'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalizedListCarousel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _carouselBase = require('@bibliocommons/carousel-base');

var _carouselBase2 = _interopRequireDefault(_carouselBase);

var _listCard = require('@bibliocommons/list-card');

var _listCard2 = _interopRequireDefault(_listCard);

var _reactIntl = require('react-intl');

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

require('../styles/ListCarousel.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ListCarousel = function ListCarousel(_ref) {
  var headingTag = _ref.headingTag,
      carouselTitle = _ref.carouselTitle,
      listItems = _ref.listItems,
      carouselSettings = _ref.carouselSettings,
      cardHeadingTag = _ref.cardHeadingTag,
      carouselTitleLink = _ref.carouselTitleLink;

  var renderListCard = function renderListCard(list) {
    return _react2.default.createElement(_listCard2.default, _extends({ key: list.listId }, list, { cardHeadingTag: cardHeadingTag }));
  };
  var titleData = { headingTag: headingTag, carouselTitle: carouselTitle, carouselTitleLink: carouselTitleLink };

  return _react2.default.createElement(
    'div',
    { className: 'cp-list-carousel' },
    _react2.default.createElement(
      _carouselBase2.default.BaseCarousel,
      _extends({}, carouselSettings, { titleData: titleData }),
      _lodash2.default.map(listItems, renderListCard)
    )
  );
};

ListCarousel.propTypes = {
  headingTag: _react.PropTypes.string,
  cardHeadingTag: _react.PropTypes.string,
  carouselTitle: _react.PropTypes.string.isRequired,
  carouselTitleLink: _react.PropTypes.string,
  listItems: _react.PropTypes.arrayOf(_react.PropTypes.object.isRequired).isRequired,
  carouselSettings: _bcPropTypes.carouselSettingShape
};

ListCarousel.defaultProps = {
  listItems: [],
  headingTag: 'h1',
  cardHeadingTag: 'h2',
  carouselSettings: {
    buttonBackgroundColor: '#fff',
    breakpointSettings: {
      1000000: {
        showDots: true,
        useTouchArrows: false,
        itemsPerPage: 4,
        gutterSize: '20px',
        partiallyShowOffscreenItems: false
      },
      1280: {
        showDots: true,
        useTouchArrows: false,
        itemsPerPage: 4,
        gutterSize: '20px',
        partiallyShowOffscreenItems: false
      },
      991: {
        showDots: true,
        useTouchArrows: false,
        itemsPerPage: 3,
        gutterSize: '40px',
        partiallyShowOffscreenItems: false
      },
      767: {
        showDots: true,
        useTouchArrows: true,
        itemsPerPage: 2,
        gutterSize: '20px',
        partiallyShowOffscreenItems: true
      },
      575: {
        showDots: true,
        useTouchArrows: true,
        itemsPerPage: 1,
        gutterSize: '20px',
        partiallyShowOffscreenItems: true
      }
    }
  }
};

exports.default = ListCarousel;
var LocalizedListCarousel = function LocalizedListCarousel(_ref2) {
  var messages = _ref2.messages,
      locale = _ref2.locale,
      carouselProps = _objectWithoutProperties(_ref2, ['messages', 'locale']);

  return _react2.default.createElement(
    _reactIntl.IntlProvider,
    { messages: messages, locale: locale },
    _react2.default.createElement(ListCarousel, carouselProps)
  );
};

exports.LocalizedListCarousel = LocalizedListCarousel;
LocalizedListCarousel.propTypes = {
  messages: _react.PropTypes.objectOf(_react.PropTypes.string).isRequired,
  locale: _react.PropTypes.string.isRequired
};

LocalizedListCarousel.defaultProps = {
  locale: 'en',
  messages: {}
};


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/carousel/list-carousel/lib/components/ListCarousel.component.js
// module id = 995
// module chunks = 5